<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'ChangeLogList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Change Log
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Change Log</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="ChangeLog">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group required">
                    <label class="control-label">AP Mac</label>
                    <input
                      type="text"
                      id="ap_wi_mac"
                      name="ap_wi_mac"
                      v-bind:class="{ 'has-error': errors.has('ap_wi_mac') }"
                      v-validate="'required'"
                      v-model="value.ap_wi_mac"
                      class="form-control ap_wi_mac"
                      placeholder="AP Mac"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('ap_wi_mac')"
                    >
                      {{ errors.first('ap_wi_mac') }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Acttype</label>
                    <select
                      class="form-control"
                      style="width: 100%"
                      name="acttype"
                      v-model="value.acttype"
                      id="acttype"
                    >
                      <option value="home">home</option>
                      <option value="go">go</option>
                      <option value="goios">goios</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Sync Process</label>
                    <input
                      type="text"
                      id="syncProcess"
                      name="syncProcess"
                      v-model="value.syncProcess"
                      class="form-control syncProcess"
                      placeholder="Sync Process"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Device List</label>
                    <input
                      type="text"
                      id="devicelist"
                      name="devicelist"
                      v-model="value.devicelist"
                      class="form-control devicelist"
                      placeholder="Device List"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Change Flag</label>
                    <input
                      type="text"
                      id="changeFlag"
                      name="changeFlag"
                      v-model="value.changeFlag"
                      class="form-control changeFlag"
                      placeholder="Change Flag"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Attempted</label>
                    <input
                      type="text"
                      id="attempted"
                      name="attempted"
                      v-model="value.attempted"
                      class="form-control attempted"
                      placeholder="Attempted"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Insert Time</label>
                    <input
                      type="text"
                      id="insertTime"
                      name="insertTime"
                      v-model="value.insertTime"
                      class="form-control insertTime"
                      placeholder="Insert Time"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Last Update</label>
                    <input
                      type="text"
                      id="lastUpdate"
                      name="lastUpdate"
                      v-model="value.lastUpdate"
                      class="form-control lastUpdate"
                      placeholder="Last Update"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Update ID</label>
                    <input
                      type="text"
                      id="update_id"
                      name="update_id"
                      v-model="value.update_id"
                      class="form-control update_id"
                      placeholder="Update ID"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'ChangeLogForm',
  metaInfo: {
    title: 'Change Log | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.is_loading = true
          let api_url = '/change_logs'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/change_logs/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'ChangeLogList' })
            })
            .catch(errors => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message)
              }
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/change_logs/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
          })
          .catch(error => {
            console.log(error.response)
          })
      }

      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
